import { render, staticRenderFns } from "./dialogFormat.vue?vue&type=template&id=94be6f3e&lang=pug"
import script from "./dialogFormat.vue?vue&type=script&lang=js"
export * from "./dialogFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports